import React, { useEffect, useRef, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { FaEye } from 'react-icons/fa';
import Button from '../../components/buttons/Button';
import { Link } from 'react-router-dom';
import Dropdown from '../../components/inputFields/DropDown';
import { getInvoices, patchInvoices } from '../../services/clinic/invoice';
import { toast } from 'react-toastify';
import ViewPdfModalFromComponent from '../../components/PdfViewer/ViewPdfModalFromComponent';
import { getUserName } from '../../utils/localStoarege';
import { line } from 'framer-motion/client';
import { getCenterMedicinesHistory } from '../../services/clinic/centers';
import { formatDateTime } from '../../utils/FormatDateTime';


function CenterMedicines() {
    const [tableData, setTableData] = useState({});

    const headers = [
        // { label: "Alloted Date", key: "created_at" },
        { label: "Medicine", key: "medicine_name" },
        { label: "Amount", key: "amount" },
        { label: "Stock Quantity", key: "quantity" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});


    const pageSize = 10;

    const fetchData = async (centerName) => {
        setLoading(true);
        try {
            let res = await getCenterMedicinesHistory(centerName);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch doses");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Machines:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData(getUserName());
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openPdfModal = (values) => {
        setPdfToDisplay(values);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleApprovalChange = async (id, value) => {
        try {
            let res = await patchInvoices(id, value);
            if (res.status === 200) {
            } else {
                toast.error("Error Updating Status");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Machines:", error);
        } finally {
            setLoading(false);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Center Medicines', },
        ]} />
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"History"} />
            {/* <Link to='/medicine/add'>
                <Button children={"Add Medicine"} className="bg-primary text-white rounded-lg" />
            </Link> */}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                // created_at: <p>{formatDateTime(item.created_at)}</p>,
                                medicine_name: <p>{item.medicine_name}</p>,
                                amount: <p>₹{item.amount}</p>,
                                quantity: <p>{item.stock_qt}</p>,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <ViewPdfModalFromComponent contentLabel={"PDF"} isOpen={modalIsOpen} onRequestClose={closeModal} values={pdfToDisplay} />
    </>);
}

export default CenterMedicines;